
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26 26"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#50585B","stroke-width":"1.1","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M11.222 3.667a9.885 9.885 0 00-4.818 1.26 10.392 10.392 0 00-3.681 3.48 10.965 10.965 0 00-1.674 4.88 11.088 11.088 0 00.73 5.128 10.642 10.642 0 002.958 4.164 10.044 10.044 0 004.491 2.216 9.813 9.813 0 004.962-.254 10.15 10.15 0 004.26-2.665l-7.228-7.543V3.667z"}}),_c('path',{attrs:{"d":"M25 11.222a9.853 9.853 0 00-.812-3.912 10.204 10.204 0 00-2.312-3.316 10.71 10.71 0 00-3.46-2.216A11.071 11.071 0 0014.332 1v10.222H25zm-3.254 9.895a10.21 10.21 0 002.408-3.316c.559-1.24.846-2.57.846-3.912H13.889l7.857 7.228z"}})])])
          )
        }
      }
    